"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardEditDialogContent = exports.DashboardAddDialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const list_source_hook_1 = require("../../utils/list-source-hook");
const dialog_1 = require("../../components/dialog/dialog");
const select_1 = require("../../components/select/select");
const dashboard_context_1 = require("./dashboard-context");
exports.DashboardAddDialog = react_1.forwardRef(
// eslint-disable-next-line no-empty-pattern
function DashboardAddDialog({}, ref) {
    const intl = react_intl_1.useIntl();
    const [value, setValue] = react_1.useState(null);
    const { loadDashboard, saveDashboard } = react_1.useContext(dashboard_context_1.DashboardContext);
    const onConfirm = event_callback_hook_1.useEventCallback(() => {
        if (value != null) {
            const items = loadDashboard();
            saveDashboard([...items, value]);
        }
    });
    const onShow = event_callback_hook_1.useEventCallback(() => {
        setValue(null);
    });
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: intl.formatMessage({
            id: 'EAS_DASHBOARD_ADD_DIALOG_TITLE',
            defaultMessage: 'Přidat prvek',
        }), onConfirm: onConfirm, onShow: onShow }, () => (react_1.default.createElement(DashboardEditDialogContent, { value: value, onChange: setValue, selected: loadDashboard() }))));
});
function DashboardEditDialogContent({ value, onChange, selected, }) {
    const intl = react_intl_1.useIntl();
    const { definitions } = react_1.useContext(dashboard_context_1.DashboardContext);
    const filteredDefinitions = definitions.filter((definition) => definition.dashboardSupport && !selected.includes(definition.id));
    const source = list_source_hook_1.useStaticListSource(filteredDefinitions);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Typography_1.default, null, intl.formatMessage({
            id: 'EAS_DASHBOARD_ADD_DIALOG_MSG',
            defaultMessage: 'Vyberte prvek, který chcete vložit na nástěnku',
        })),
        react_1.default.createElement(select_1.Select, { source: source, value: value, onChange: onChange, labelMapper: (o) => o.label, valueIsId: true })));
}
exports.DashboardEditDialogContent = DashboardEditDialogContent;
//# sourceMappingURL=dashboard-add-dialog.js.map